module.exports = __webpack_public_path__ + "static/media/tgle-Katharsis.f06f58b8.png";